import houseImage from "./images/domek.webp"

export const housesData = {
    id: "cottages",
    title: `Domki "Zamkowe wzgórze" w Niedzicy`,
    description: ` Zapraszamy do odkrycia wyjątkowego miejsca na wypoczynek – naszych dwóch komfortowych domków, położonych w malowniczej scenerii Jeziora Czorsztyńskiego, tuż u stóp historycznego Zamku w Niedzicy. To idealne połączenie natury, historii i nowoczesnego komfortu, stworzone z myślą o niezapomnianych chwilach dla całej rodziny lub grupy przyjaciół.` ,
    imageSrc: houseImage,
    imageAlt: "Cozy lakeside cottage for rent in Niedzica",
    linkHref: "https://www.booking.com/hotel/pl/zamkowe-wzgorze.pl.html",
    linkText: "Zamkowe wzgórze - Booking.com",
    linkTarget: "_blank",
    linkRel: "noopener noreferrer",
};